import * as CubeTree from '../cubeTree/index';
import Utils from '../utils/util';

function getCubeValue(target: CubeId, key: string): any {
    let targetCube: CubeNode|null = CubeTree.findByCubeId(target);

    if (!targetCube) {
        return null;
    }

    return Utils.getMapValueByStringKey(targetCube, key);
}

export {
    getCubeValue
};
